import { useTranslate } from '@ur-solutions/react-hooks'

interface WholeDayRounding {
  changedCount: number
  shortCount: number
  overlapCount: number
}

interface Props {
  rounding: WholeDayRounding
}

export function WholeDayRoundingNotice({ rounding }: Props) {
  const translations = useTranslate({
    changed: ['settings.absence.whole-day-rounding.changed', { count: 0 }],
    short: ['settings.absence.whole-day-rounding.short', { count: 0 }],
    overlap: ['settings.absence.whole-day-rounding.overlap', { count: 0 }],
  })

  if (rounding.changedCount === 0) return null

  return (
    <div className="rounded-md bg-amber-50 p-3 text-sm text-pretty text-amber-800">
      <p>{translations.changed({ count: rounding.changedCount })}</p>
      {rounding.shortCount > 0 && (
        <p>{translations.short({ count: rounding.shortCount })}</p>
      )}
      {rounding.overlapCount > 0 && (
        <p>{translations.overlap({ count: rounding.overlapCount })}</p>
      )}
    </div>
  )
}
